import { intelligentPhotoCaptureConstants } from '../constants';
export const INTELLIGENT_PHOTO_CAPTURE_SHOW_TOAST = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_SHOW_TOAST`;
export const INTELLIGENT_PHOTO_CAPTURE_RESET_TOAST = `${intelligentPhotoCaptureConstants.MODULE_PREFIX}_RESET_TOAST`;
/**
 * Action creator to show a toast notification.
 * @param operationType - Assignment summary operation type associated with the toast notification.
 * @param toastType - The visual type of the toast (e.g. Success, Error).
 * @param customMessage - The custom message to display in the toast.
 */
export const showIntelligentPhotoCaptureToastAction = (operationType, toastType, customMessage) => ({
    type: INTELLIGENT_PHOTO_CAPTURE_SHOW_TOAST,
    payload: { operationType, toastType, customMessage }
});
/**
 * Action creator to reset the current toast notification.
 */
export const resetIntelligentPhotoCaptureToastAction = () => ({
    type: INTELLIGENT_PHOTO_CAPTURE_RESET_TOAST,
    payload: undefined
});
//# sourceMappingURL=photoCaptureIntelligentToastAction.js.map